const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        // Skip if this is on product page (variant-radios will handle it)
        if (
          input.closest("variant-radios") ||
          input.closest("variant-selects")
        ) {
          return;
        }

        // Skip if this is inside product-section (product page)
        if (input.closest(".product-section")) {
          return;
        }

        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (!event.currentTarget.checked) return;

        const variantId = event.currentTarget.dataset.variantId;
        const linkedProductUrl = event.currentTarget.dataset.productUrl;
        const productUrl =
          linkedProductUrl ||
          window.Shopify.routes.root +
            "products/" +
            handleProduct +
            (variantId ? "?variant=" + variantId : "");

        wrapper.querySelectorAll(".js-color-swatches-link").forEach((link) => {
          link.setAttribute("href", productUrl);
        });

        wrapper.querySelectorAll("modal-opener button[data-product-url]").forEach((button) => {
          button.setAttribute("data-product-url", productUrl);
        });

        const currentColor = event.currentTarget.value;

        jQuery.getJSON(
          window.Shopify.routes.root + `products/${handleProduct}.js`,
          function (product) {
            const variant = product.variants.find(
              (item) =>
                item.featured_media != null &&
                item.options.includes(currentColor)
            );

            if (!variant) {
              return;
            }

            // Check for data-section
            const sectionId = wrapper.dataset.section || "default-section";
            const mediaId = variant.featured_media.id;

            // If not all data is present
            if (!sectionId || !mediaId) {
              return;
            }

            const swiperWrappers = document.querySelectorAll(
              ".global-variant-slider"
            );

            //const newPrimaryImage = variant.featured_media;
            swiperWrappers.forEach((elem) => {
              if (!elem.classList.contains("hidden")) {
                const mediaList = elem.querySelector(
                  ".js-media-list, .global-variant-js-media-list"
                );

                if (mediaList?.swiper) {
                  // If this is a slider, then switch the slide

                  const mediaIdString = `${sectionId}-${mediaId}`;

                  // Search for element by mediaId
                  const newMedia = document.querySelector(
                    `[data-media-id="${mediaIdString}"]`
                  );

                  if (!newMedia) {
                    return;
                  }

                  const targetIndex = mediaList.swiper.slides.indexOf(newMedia);
                  if (targetIndex !== -1) {
                    mediaList.swiper.slideTo(targetIndex);
                  }
                } else {
                  // If it's not a slider, then add media to the parent element
                  if (variant) {
                    const newPrimaryImage = createImageElement(
                      variant["featured_media"],
                      primaryImage.className,
                      primaryImage.sizes,
                      product.title
                    );

                    if (newPrimaryImage.src !== primaryImage.src) {
                      let flag = false;
                      if (secondaryImage) {
                        const secondaryImagePathname = new URL(
                          secondaryImage.src
                        ).pathname;
                        const newPrimaryImagePathname = new URL(
                          newPrimaryImage.src
                        ).pathname;

                        if (secondaryImagePathname == newPrimaryImagePathname) {
                          primaryImage.remove();
                          secondaryImage.classList.remove("media--second");
                          secondaryImage.classList.add("media--first");
                          flag = true;
                        }
                      }
                      if (flag == false) {
                        primaryImage.animate(
                          { opacity: [1, 0] },
                          { duration: 200, easing: "ease-in", fill: "forwards" }
                        ).finished;
                        setTimeout(function () {
                          primaryImage.replaceWith(newPrimaryImage);
                          newPrimaryImage.animate(
                            { opacity: [0, 1] },
                            { duration: 200, easing: "ease-in" }
                          );
                          if (secondaryImage) {
                            secondaryImage.remove();
                          }
                        }, 200);
                      }
                    }
                  }
                }
              }
            });
          }
        );
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();
